import axios from "axios";
import ApiService from "@/services/api.service";
import {
  DepartedVesselsService,
  DeliveryOrderService
} from "@/services/api.service";
import { API_URL } from "@/services/config.service";

const state = {
  do_items: null,
  do_details: null,
  delivery_order: null,
  jsreport: null,
  do_dashboard_data: null,
  delivery_orders: null,
  action_menu_view: null,
  sheet_number: null,
  charges: null,
  periods: null,
  holidays: null,
  weekends: null,
  loading: false,
  loading_do_items: false,
  apiUrl: API_URL + "/departed_vessels",
  axiosConfig: {
    headers: {
      "Content-Type": "application/json"
    }
  }
};

const getters = {
  // allDepartedVessels: state => state.departed_vessels
  //all_do: state => state.do_items,
  do: state => state.delivery_order,
  do_details: state => state.do_details
};

const mutations = {
  msetDoItems: (state, payload) => (state.do_items = payload),
  //setDoDetails: (state, payload) => (state.do_details = payload),
  msetDO: (state, payload) => (state.delivery_order = payload),
  msetDOs: (state, payload) => (state.delivery_orders = payload),
  msetJSReport: (state, payload) => (state.jsreport = payload),
  msetSheetNumber: (state, payload) => (state.sheet_number = payload),
  msetDODashboardData: (state, payload) => (state.do_dashboard_data = payload),
  setActionMenuView: (state, payload) => (state.action_menu_view = payload),
  setLoading: (state, payload) => (state.loading = payload),
  setLoadingDoItems: (state, payload) => (state.loading_do_items = payload)
};

const actions = {
  fetchDeliveryOrders: async ({ state, commit }) => {
    commit("setLoading", true);
    try {
      const response = await DeliveryOrderService.get();
      commit("msetDOs", response.data.delivery_orders);
      //return response.data.delivery_orders;
    } catch (error) {
      commit("msetDOs", []);
    }
    commit("setLoading", false);
  },

  fetchDeliveryOrdersByVessel: async ({ state, commit }, payload) => {
    commit("setLoading", true);
    if (state.do_items) {
      commit("msetDoItems", []);
    }

    try {
      const response = await DeliveryOrderService.get_by_vessel(payload);
      // console.log("do res", response.data);
      commit("msetDOs", response.data.delivery_orders);
      //return response.data.delivery_orders;
    } catch (error) {
      commit("msetDOs", []);
    }
    commit("setLoading", false);
  },
  fetchDeliveryOrderByID: async ({ state, commit }, payload) => {
    commit("setLoading", true);
    try {
      const response = await DeliveryOrderService.get_by_id(payload);
      // console.log("do res", response.data);
      commit("msetDO", response.data.delivery_order);
      //return response.data.delivery_orders;
    } catch (error) {
      commit("msetDO", []);
    }
    commit("setLoading", false);
  },

  fetchDoItems: async ({ state, commit }, payload) => {
    commit("setLoadingDoItems", true);
    try {
      const response = await DeliveryOrderService.get_do_items(payload);
     // console.log("do items res", response.data);
      commit("msetDoItems", response.data.delivery_order_items);
      //return response.data.delivery_order_items;
    } catch (error) {
      commit("msetDoItems", []);
    }
    commit("setLoadingDoItems", false);
  },

  aGetJSReport: async ({ state, commit }, payload) => {
    //commit("setLoadingDoItems", true);
    //console.log("payload", payload);
    try {
      const response = await DeliveryOrderService.get_jsreport(
        "do_jsreport",
        payload
      );
      if (response.status === 200) {
        commit("msetJSReport", response.data);
        return response;
      }
      //console.log("report data", response);
    } catch (error) {
      commit("msetJSReport", []);
    }
    // commit("setLoadingDoItems", false);
  },

  async setDelivery({ context, commit }, payload) {
    //console.log("set delivery", payload);
    try {
      const response = await DeliveryOrderService.set_delivery(
        "set_delivery/" + payload["id"],
        payload
      );
      //console.log("success", response.data);
      return response.data.message;
    } catch (error) {
      return error;
    }
    // context.dispatch("")
  },

  async addWaver({ context, commit }, payload) {
   // console.log("add waver", payload);
    try {
      const response = await DeliveryOrderService.add_waver(
        "add_waver/" + payload["id"],
        payload
      );
      //console.log("success", response.data);
      return response.data.message;
    } catch (error) {
      return error;
    }
    // context.dispatch("")
  },
  async verifyDO({ context, commit }, payload) {
   // console.log("verify DO", payload);
    try {
      const response = await DeliveryOrderService.verify_do(
        "verify_do/" + payload["id"],
        payload
      );
      return response.data.message;
    } catch (error) {
      return error;
    }
    // context.dispatch("")
  },
  async authorisedDelivery({ context, commit }, payload) {
    //console.log("authorised delivery", payload);
    try {
      const response = await DeliveryOrderService.authorised_delivery(
        "authorised_delivery/" + payload["id"],
        payload
      );
      return response.data.message;
    } catch (error) {
      return error;
    }
    // context.dispatch("")
  },

  async arateAgain({ context, commit }, payload) {
    //console.log("rate again", payload);
    try {
      const response = await DeliveryOrderService.rate_again(
        "rate_again/" + payload["id"],
        payload
      );
      //console.log("success", response.data);
      return response.data.message;
    } catch (error) {
      return error;
    }
    // context.dispatch("")
  },

  async addDeliveryOrder({ context, commit }, payload) {
    //console.log("save delivery order", payload);
    commit("msetDoItems", null);
    const response = await DeliveryOrderService.post("add", payload);
    if (response.status === 200) {
      const number = response.data.sheet_number;
      commit("msetSheetNumber", number);
    }
    //context.dispatch("fetchDeliveryOrders");
  },

  /*async addItems({ state, commit }, payload) {
    if (payload) {
      commit("setDoItems", payload);
    }
  }*/
  asetDeliveryOrder: function({ commit }, payload) {
    commit("msetDO", payload);
    //console.log("commit do ", state.delivery_order);
  },
  asetDODashboardData: function({ commit }, payload) {
    commit("msetDODashboardData", payload);
    //console.log("commit dashboard data");
  },
  asetDeliveryOrders: function({ commit }, payload) {
    commit("msetDOs", payload);
    //console.log("commit dos ", state.delivery_orders);
  },
  asetDOItems: function({ commit }, payload) {
    commit("msetDoItems", payload);
    //console.log("commit dos ", state.delivery_orders);
  },
  asetActionMenuView: function({ commit }, payload) {
    commit("setActionMenuView", payload);
    //console.log("commit selected vessel ", payload.item);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
